import styled from 'styled-components';
import { BORDER_COLOR } from '../../constants';
import { desktopMediaQuery } from '../../styleHelpers';

export const SectionSeparator = styled.div`
  height: 8px;
  width: 100%;
  border-bottom: 0.5px dotted ${BORDER_COLOR};

  margin-top: 32px;
  margin-bottom: 16px;

  ${desktopMediaQuery} {
    margin-left: 5vw;
  }
`;
